import _ from 'lodash';
import numeral from 'numeral';
import { PointModel } from '../../models/point.model';
import api from '../api';
import dialogBox from '../core/dialog';
import infoBoard from '../core/infoboard';
import worldMap from '../core/map';
import halo from '../core/map/halo';
import templates from '../core/templates';
import translate from '../core/tools/translate';
import environment from '../environment';
import layers from '../layers';
import { customScrollbar } from '../shared';
import { notify, NOTIFY_TYPE } from '../shared/notify';
// import 'mapbox.js';

const LayerControls = (name) => require('../controls').get(name);
const LayerInfo = (name) => require('../info').get(name);

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

let _marker = null;
let _buffer = null;
let model;

let container = null;

const _getContainer = name =>
    infoBoard.createContainer({
        id: 'create-point',
        name,
        visible: true,
        wrapper: 'infoboard-view'
    });

const _getTemplate = (type, values) => {
    try {
        values.isAfterSales = environment.get('CONFIG.IS_AFTER_SALES');

        switch (type) {
        case 'footer':
            return templates('shared-action-bar', values);
        default:
            return templates(`${type.toLowerCase()}-edit-view`, values);
        }
    } catch (err) {
        console.log(err);
    }
};

const _createMarker = (latlng) => {
    if (_marker) {
        worldMap.removeLayer(_marker);
    }

    _marker = L.marker(latlng, {
        zIndexOffset: 999999,
        riseOnHover: true,
        draggable: true,
        icon: L.icon({
            iconUrl: `${environment.get('IMAGES_HOST')}/pin_point_new.png`,
            iconSize: [50, 64], // size of the icon
            iconAnchor: [25, 62] // marker's location
        })
    }).addTo(worldMap.get());
    return _onDragEnd();
};

const _removeFeature = (layer, feature) => {
    layer.removeLayer(feature.properties.Id);
    halo.remove();
};

const _onDragEnd = () =>
    _marker.on('dragend', () => {
        api.general.get.geocode({
            lat: _marker.getLatLng().lat,
            lng: _marker.getLatLng().lng
        }).then(res => {
            res.coordinates.lat = _marker.getLatLng().lat;
            res.coordinates.lng = _marker.getLatLng().lng;
            updateForm(res);
            if (model.name) {
                model.address.state = _selectIndex(res.state, _getDataSource('UF')) + 1;
                model.address.address = res.route;
                model.address.district = res.neighborhood;
                model.address.city = res.city;
                model.address.zip = res.postalCode;
                model.location = {
                    latitude: _marker.getLatLng().lat,
                    longitude: _marker.getLatLng().lng
                };
            }
        });

        $('#form-create-point').find('button[name="CalculateArea"]').trigger('click');
    });

const updateForm = (location) => {
    const form = $('#form-create-point');

    if (!location || form.length === 0) {
        return;
    }

    const street = location.route ? location.route : location.street ? location.street : '';

    form.find('input[name="FederativeUnit"]').data('kendoDropDownList').select(_selectIndex(location.state, _getDataSource('UF')));
    form.find('input[name="Logradouro"]').val(street);
    form.find('input[name="Neighborhood"]').val(location.neighborhood);
    form.find('input[name="County"]').val(location.city);
    form.find('input[name="Cep"]').val(location.postalCode);
    form.find('input[name="Latitude"]').val(location.coordinates.lat);
    form.find('input[name="Longitude"]').val(location.coordinates.lng);

    return form.find('input[type="text"]').each((index, target) => infoBoard.updateInputLabel(target));
};

const _submitForm = type => {
    const form = $('#form-create-point').serializeObject();

    if (!validateAnelValues()) return;
    
    if (_buffer) {
        form.geojson = _buffer.layer.toGeoJSON();
        form.Anel1 = $('input[name="Anel1"]').val();
        form.Anel2 = $('input[name="Anel2"]').val();
        form.Anel3 = $('input[name="Anel3"]').val();
    }

    if (form.Id) {
        return api.poi.update(form);
    } else {
        form.geojson = null;
        return api.poi.add(form);
    }
};

const _selectIndex = (value, data) => _.findIndex(data, d => String(d.value).toLowerCase() === String(value).toLowerCase());

const _createDropdown = (input, label, data, index) => {
    const options = {
        filter: data.length > 9 ? 'contains' : 'none',
        dataTextField: 'text',
        dataValueField: 'value',
        dataSource: data
    };
    if (index > 0) {
        options.index = index;
    }

    input.kendoDropDownList(options);
    setTimeout(() => {
        if (label && input.data('kendoDropDownList') && index === -1) {
            input.data('kendoDropDownList').text(label);
        }
    }, 300);
};

const _getDataSource = name => {
    switch (name) {
        case 'UF':
            return environment.get('CONFIG.STATES');
    }
};

const _createDropdownList = (feature, form) => {
    let dataSource = _getDataSource('UF');
    let input = form.find('input[name="FederativeUnit"]');
    _createDropdown(input, '', dataSource, _selectIndex(feature.properties.UF, dataSource));
};

const validateAnelValues = () => {
    const anel1 = $('input[name="Anel1"]').val();
    const anel2 = $('input[name="Anel2"]').val();
    const anel3 = $('input[name="Anel3"]').val();

    let valid = true;

    if (anel1 && !isValidPositiveNumber(anel1)) {
        notify(NOTIFY_TYPE.ERROR, translate('Error.NotValidRadius'));
        valid = false;
    }

    if (anel2 && !isValidPositiveNumber(anel2)) {
        notify(NOTIFY_TYPE.ERROR, translate('Error.NotValidRadius'));
        valid = false;
    }

    if (anel3 && !isValidPositiveNumber(anel3)) {
        notify(NOTIFY_TYPE.ERROR, translate('Error.NotValidRadius'));
        valid = false;
    }

    return valid;
};

const isValidPositiveNumber = (val) => {
    const num = Number(val);
    return !isNaN(num) && num >= 1;
};

class CreatePointInfo {
    static getInstance () {
        if (!CreatePointInfo._instance) {
            CreatePointInfo._instance = new CreatePointInfo();
        }

        return CreatePointInfo._instance;
    }

    init () {
    }

    edit (layer, feature, type) {
        if (!type) {
            type = _.values(environment.get('CONFIG.FILTERS.POINTS_TYPES'))[0];
        }

        if (feature && layer) {
            _createMarker(layer.getLayer(feature.properties.Id).getLatLng());
            _removeFeature(layer, feature);
            api.poi.getPoi(feature.properties.Id).then(response => {
                feature.properties.Name = response.information.nome;
                feature.properties.Logradouro = response.address.endereco;
                feature.properties.Neighborhood = response.address.bairro;
                feature.properties.County = response.address.cidade;
                feature.properties.FederativeUnit = response.address.uf;
                feature.properties.Cep = response.address.cep;
                feature.properties.Description = response.information.descricao;
                feature.properties.Latitude = response.location.latitude;
                feature.properties.Longitude = response.location.longitude;
            });
        } else if (!feature) {
            feature = {
                properties: {
                    Name: '',
                    Logradouro: '',
                    Neighborhood: '',
                    County: '',
                    FederativeUnit: '',
                    Cep: '',
                    Description: ''
                }
            };
        }

        infoBoard.open();

        model = new PointModel(feature, type);
        container = _getContainer(translate('Common.RegistrationForm'));
        const form = $(_getTemplate(type, model));
        form.appendTo(container);
        const footer = $(_getTemplate('footer', { cancel: true }));
        footer.appendTo(container);

        _createDropdownList(feature, form);
        this._configForm(form, footer);

        footer.find('.action-cancel').on('click', () => {
            if (layer) {
                layer.reset();
            }
        });

        form.find('form').on('submit', (e) => {
            e.preventDefault();
            _submitForm('', e);
            this._resetView();
            LayerControls('PointOfInterest').check(true);
        });

        customScrollbar(form);
    }

    addMarker (latlng) {
        if (_marker) {
            _marker.setLatLng(latlng).addTo(worldMap.get()).update();
        } else {
            _createMarker(latlng);
        }

        this._dialog();
    }

    updateByGeocode(location) {
        updateForm(location);
    }

    reset () {
        if (_marker && worldMap.hasLayer(_marker)) {
            worldMap.removeLayer(_marker);
            _marker = null;
        }

        if (_buffer) {
            _buffer.clear();
            _buffer = null;
        }
    }

    _resetView () {
        this.reset();
        $('#infoboard-view').hide();
        $('#create-point-tab-link').remove();

        $(container).empty();

        infoBoard.locked = false;
    }

    _dialog () {
        const inputs = [];

        _.forEach(environment.get('CONFIG.FILTERS.POINTS_TYPES'), (value, name) => {
            if (isAuthorized(`${value}-edit`)) {
                return inputs.push({
                    text: name,
                    type: value
                });
            }
        });

        const _submit = value => {
            return this.edit(undefined, undefined, value);
        };

        const _close = () => worldMap.removeLayer(_marker);

        if (inputs.length > 1) {
            return dialogBox.select(inputs, _submit, _close);
        } else {
            return this.edit();
        }
    }

    _confirmUnrestrict (checkbox) {
        dialogBox.confirmation({
            icon: 'unlock-alt',
            title: translate('Common.Restriction'),
            subtitle: translate('Message.UnrestrictPointSubtitle'),
            message: translate('Message.UnrestrictPointConfirm')
        }, null, () => checkbox.iCheck('check'));
    }

    _configForm (form, footer) {
        const validator = form.find('form').parsley();

        form.find('button[name="CalculateArea"]').on('click', (e) => {
            e.preventDefault();

            const button = $(e.target);
            const submit = footer.find('.action-submit');
            button.prop('disabled', true);
            submit.attr('disabled', true);

            if (!validateAnelValues()) {
                button.prop('disabled', false);
                submit.attr('disabled', false);
                return;
            };


            infoBoard.locked = true;
            LayerControls('ServiceArea').check(false);

            const _handleSuccess = (response) => {
                _buffer = layers.get('ServiceArea');
                _buffer.setFeatures(response, true);
                button.prop('disabled', false);
                submit.attr('disabled', false);
            };

            const _handleError = () => {
                notify(NOTIFY_TYPE.ERROR, translate('Error.FailProcessArea'));
                submit.attr('disabled', false);
                button.prop('disabled', false);
            };

            LayerInfo('Summary').calculateTradeArea(form, _marker.getLatLng()).then(_handleSuccess, _handleError);
        });

        form.on('keyup keypress blur change', 'input[type="text"], input[type="number"], input[type="tel"], textarea', (e) => {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
            infoBoard.updateInputLabel(e.target);
        });

        form.find('input[type="text"], input[type="number"], input[type="tel"], textarea').each((index, target) => infoBoard.updateInputLabel(target));

        form.find('input[type="radio"], input[type="checkbox"]').not('[name="IsRestrict"]').show().iCheck({
            radioClass: 'iradio_square-blue',
            checkboxClass: 'icheckbox_square-blue'
        });

        form.find('input[name="IsRestrict"]').show().iCheck({
            checkboxClass: 'iradio_square-blue'
        }).on('ifUnchecked', (e) => this._confirmUnrestrict($(e.target)));

        $(_marker).on('dragend', (e) => {
            form.find('input[name="Latitude"]').val(_marker.getLatLng().lat);
            form.find('input[name="Longitude"]').val(_marker.getLatLng().lng);
        });

        form.find('input[name="Latitude"]')
            .add('input[name="Longitude"]')
            .on('change', (e) => {
                e.preventDefault();
                const latlng = L.latLng($('input[name="Latitude"]').val(), $('input[name="Longitude"]').val());
                _marker.setLatLng(latlng);
            });

        footer.find('.action-cancel').on('click', () => this._resetView());

        footer.find('.action-submit').on('click', (e) => {
            e.preventDefault();
            if (validator.validate()) {
                form.find('form').submit();
            } else {
                console.log('Form is not valid');
            }
        });

        form.find('button[name="CalculateArea"]').trigger("click");
    }
}

export default CreatePointInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/CreatePointInfo.js